import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Close = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Close" {...props}>
    <path d="M18.2931 4.29308C18.6836 3.90264 19.3166 3.90258 19.7071 4.29308C20.0976 4.68358 20.0975 5.31663 19.7071 5.70714L13.4142 12.0001L19.7071 18.2931C20.0975 18.6836 20.0976 19.3167 19.7071 19.7071C19.3167 20.0976 18.6836 20.0975 18.2931 19.7071L12.0001 13.4142L5.70713 19.7071C5.31662 20.0976 4.68359 20.0976 4.29306 19.7071C3.90255 19.3166 3.90256 18.6836 4.29306 18.2931L10.586 12.0001L4.29306 5.70714C3.90255 5.31662 3.90256 4.6836 4.29306 4.29308C4.68359 3.90255 5.3166 3.90255 5.70713 4.29308L12.0001 10.586L18.2931 4.29308Z" fill="#000" />
  </StyledIcon>
));

Close.displayName = 'Close';

export { Close };
